export const getIntegerOrFloatNumber = (number, fixedCount = 1) => {
    number = Number(number);

    if (Number.isNaN(number)) {
        return 0;
    }

    if (Number.isInteger(number)) {
        return number;
    }

    const decimalPart = number - Math.floor(number);

    if (decimalPart === number) {
        return number.toFixed(fixedCount);
    }

    if (decimalPart > 0.1) {
        return number.toFixed(fixedCount);
    }

    return Math.round(number);
};

export const prettifyAmount = (number) => {
    const amount = getIntegerOrFloatNumber(number, 2);
    return Number(amount)
        .toString()
        .replace(/(\d)(?=(\d{3})+(\D|$))/g, "$1\u00A0");
};

export const checkForTimeMaskValid = (time) => {
    const [hours, minutes] = time.split(":");
    let isValid = true;

    if (+hours > 23 || +hours < 0) {
        isValid = false;
    }
    if (+minutes > 59 || +minutes < 0) {
        isValid = false;
    }

    return isValid;
};
